<pc-error-popup
  [buttonText]="buttonText()"
  [closePopUpAriaLabel]="closePopUpAriaLabel()"
  [contentClass]="'dynamic-height'"
  [description]="description()"
  [desktopImgPath]="desktopImgPath()"
  [imgAlt]="imgAlt()"
  [information]="information()"
  [isCloseIcon]="true"
  [mobileImgPath]="mobileImgPath()"
  [submitButtonIcon]="PcButtonIcon.RIGHT_ARROW"
  [title]="title()"
  (closeErrorDialog)="closeDialog()"
  (closeWithSubmit)="closeWithSubmit()"
>
  <div section-content [innerHTML]="customContent()"></div>
</pc-error-popup>
